<template>

  <v-card elevation="2" flat class="my-2">
    <div class="d-flex">
      <v-card-subtitle>
        <p class="qna-name">
          {{ item.username }}
          <span class="qna-name ml-3">{{
            getTimeSingle(item.question.timeStamp)
          }}</span>
        </p>
      </v-card-subtitle>

      <v-card-actions class="mr-0 ml-auto py-0">
        <v-icon color="success" v-if="item.question.isAnswered"
          >mdi-check
        </v-icon>
        <v-badge
          v-if="canVote"
          color="transparent"
          title
          overlap
          :content="item.question.ranking"
        >
          <v-btn
            :disabled="!item.question.isPublic || item.question.isAnswered"
            icon
            :color="voted ? 'primary' : undefined"
            @click="likeQuestion"
          >
            <v-icon>mdi-thumb-up</v-icon>
          </v-btn>
        </v-badge>
      </v-card-actions>
    </div>
    <v-divider class="mx-1" />
    <div class="d-flex flex-row align-center">
      <v-card-text
        style="white-space: pre-wrap"
        v-html="item.question.question"
      ></v-card-text>
    </div>
    <v-sheet color="transparent">
      <v-card-subtitle v-if="!item.question.isPublic">
        <v-progress-linear
          height="2"
          :indeterminate="
            item.question.isPublic == false && !item.question.isDiscard
          "
        ></v-progress-linear>
        <p
          class="qna-date"
          v-if="item.question.isDiscard"
          v-html="$t('qna.question.discard')"
        ></p>
        <p class="qna-date" v-else v-html="$t('qna.question.approval')"></p>
      </v-card-subtitle>
    </v-sheet>
    <!-- <v-divider /> -->
  </v-card>

</template>

<script>
import { DateMixins } from "_shared/helpers";

export default {
  props: {
    canVote: { type: Boolean, default: true },
    item: {},
  },
  mixins: [DateMixins],
  computed: {
    voted() {
      return this.item.question.votedUser.find(
        (s) => s == this.$store.state.account.user.profile.sub
      );
    },
  },
  methods: {
    likeQuestion() {
      this.$qnahub.likeQuestion(this.item);
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}
.qna-name {
  font-family: Bold;
}
.qna-date {
  font-size: 0.75em;
}

::v-deep .v-badge__badge {
  color: rgb(0, 0, 0) !important;
}


</style>